import { render, staticRenderFns } from "./KgjtWebsiteLearnVideoEdit.vue?vue&type=template&id=b08c1e7a&scoped=true&"
import script from "./KgjtWebsiteLearnVideoEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteLearnVideoEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteLearnVideoEdit.vue?vue&type=style&index=0&id=b08c1e7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c1e7a",
  null
  
)

export default component.exports